module.exports = __webpack_public_path__ + "officialStatic/img/gw-detailList3.fbe7f0f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/gw-detailList3.jpg
// module id = jTLd
// module chunks = 0